import {h} from 'preact';
import OfferButton from "../components/OfferButton";
import OfferContainer from "../components/OfferContainer";
import style from "./main.css";
import {useContext, useEffect, useState} from "preact/hooks";
import {ConfigContext, ServiceContext} from "../AppContext";
import {PromotionModel} from "../models";


const Main = () => {
    const config = useContext(ConfigContext);
    const service = useContext(ServiceContext);
    const [promotion, setPromotion] = useState<PromotionModel | undefined>(undefined);

    useEffect(() => {
        if (config.promotion?.code) {
            service?.getPromotionByCode(config.promotion.code)
                .then(setPromotion)
        } else {
            service?.getFirstActivePromotion()
                .then(setPromotion)
        }
    }, [service]);

    if (!promotion) {
        return null;
    }

    if (config.loadCallback) {
        config.loadCallback(promotion);
    }

    return (
        <div className={style.root}>
            <OfferButton title={promotion.title.toString()}/>
            <OfferContainer text={promotion.offer.toString()}/>
        </div>
    );
};

export default Main;
